export default "__VITE_ASSET__BDCvo3tm__"